import { LoadingData } from "react-app-env";

import moment from "moment";
import "moment/locale/id";
import { useNavigate } from "react-router-dom";
import { FaListCheck } from "react-icons/fa6";

type Props = {
  data: LoadingData;
  loadingType: "in" | "out";
};

const LoadingCard = ({
  data,
  loadingType
}: Props) => {
  const navigate = useNavigate();

  const {
    _id,
    eventDate,
    eventLocation,
    pic,
    loadingDate,
    loadingTime,
    coordinator,
    coordinatorContact,
    isConfirmed,
    confirmationDate,
    adminConfirm,
    inventories
  } = data;

  const pushTo = (route: string) => {
    navigate(route, {
      state: {
        eventDate,
        eventLocation,
        pic,
        inventories
      }
    });
  };

  const todayDate = moment().format("YYYY-MM-DD");
  const eventDateMoment = moment(eventDate, "DD/MM/YYYY").format("YYYY-MM-DD");
  let showConfirmationButton = moment(eventDateMoment).isSameOrBefore(todayDate) && !isConfirmed;
  
  return (
    <div className="border border-gray-100 bg-white rounded-xl p-5 mt-7">
      <div className="flex items-center gap-2">
        <strong className="text-lg">{moment(eventDate, "DD/MM/YYYY").format("DD MMM YYYY")}</strong>
        <span>-</span>
        <strong className="text-lg">{eventLocation}</strong>
      </div>
      <hr className="border-gray-300 my-4" />
      <div className="flex items-center gap-2">
        <strong>{pic.name}</strong>
        <span>-</span>
        <strong>{pic.phone}</strong>
      </div>
      <hr className="border-gray-300 my-4" />
      <table>
        <tbody>
          <tr>
            <td>
              <label>Tgl Loading {loadingType}</label>
            </td>
            <td>
              <span className="px-2">:</span>
            </td>
            <td>
              <label>
                <strong>{moment(loadingDate, "DD/MM/YYYY").format("DD MMM YYYY")}</strong>
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <label>Jam Loading {loadingType}</label>
            </td>
            <td>
              <span className="px-2">:</span>
            </td>
            <td>
              <label>
                <strong>{loadingTime} WIB</strong>
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <label>Koordinator</label>
            </td>
            <td>
              <span className="px-2">:</span>
            </td>
            <td>
              <label>
                <strong>{coordinator?.name || coordinatorContact.name}</strong>
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <label>No. HP</label>
            </td>
            <td>
              <span className="px-2">:</span>
            </td>
            <td>
              <label>
                <strong>{coordinator?.phone || coordinatorContact.phone}</strong>
              </label>
            </td>
          </tr>
          { !isConfirmed && 
            <tr>
              <td>
                <label>List Barang</label>
              </td>
              <td>
                <span className="px-2">:</span>
              </td>
              <td className="py-2">
                { inventories.length > 0 ? 
                  <button 
                    className="px-3 py-1 rounded-xl text-sm bg-transparent border border-orange-600 text-orange-600"
                    onClick={() => {
                      pushTo("/jadwal-loading/" + loadingType + "/" + _id);
                    }}
                  >
                      Lihat List Barang
                  </button>
                : <button 
                  className="px-3 py-1 rounded-xl text-sm bg-transparent border border-orange-600 text-orange-600"
                >
                    Buat List Barang
                </button>}
              </td>
            </tr>
          }
        </tbody>
      </table>

      {loadingType === "out" && showConfirmationButton && 
        <hr className="border-gray-300 my-4" />
      }

      {loadingType === "out" && showConfirmationButton &&
        <div className='mt-5 grid grid-cols-1'>
          <button 
            className='w-full bg-orange-500 text-white py-3 md:py-4 rounded-xl flex items-center justify-center gap-2'
            onClick={() => {
              pushTo("/jadwal-loading/" + loadingType + "/" + _id);
            }}
          >
            <FaListCheck />
            Konfirmasi Loading Out
          </button>
        </div>
      }

      {isConfirmed && confirmationDate && 
        <>
          <hr className="border-gray-300 my-4" />
          <div className="bg-green-600 text-white rounded-xl mt-5 py-4">
            <p className="text-center uppercase font-semibold">Sudah Dikonfirmasi</p>
            <p className="text-center">Oleh : <strong>{adminConfirm.name}</strong></p>
            <p className="text-center">Tanggal : <strong>{moment(confirmationDate, "MM/DD/YYYY, HH:mm:ss").format("DD MMM YYYY")}</strong></p>
          </div>
        </>
      }
    </div>
  )
}

export default LoadingCard